/**
 * Bridge between the imperative refresh flow (HTTP interceptor) and the React
 * LockScreen. When a 401 needs the vault's refresh token but no key is in memory
 * this session, the interceptor calls getUnlockedRefreshToken(), which either
 * returns a cached decrypted token or asks the registered prompt to show the
 * LockScreen and resolve once the user unlocks.
 */
let cachedRefreshToken: string | null = null;
let prompt: (() => Promise<string>) | null = null;

/** LockScreen registers this; it shows the UI and resolves with the refresh token. */
export function registerUnlockPrompt(fn: (() => Promise<string>) | null): void {
  prompt = fn;
}

/** Called after a successful unlock to avoid re-prompting within the session. */
export function setCachedRefreshToken(token: string | null): void {
  cachedRefreshToken = token;
}

export async function getUnlockedRefreshToken(): Promise<string> {
  if (cachedRefreshToken) return cachedRefreshToken;
  if (!prompt) throw new Error('No unlock prompt registered');
  const rt = await prompt();
  cachedRefreshToken = rt;
  return rt;
}
